import { LoggingLevel } from "./LoggingLevel";

/**
 * Событие, которое логируем.
 */
export class LoggingEvent {
  /**
   * Имя логгера.
   */
  logger: string;

  /**
   * Уровень лог события.
   */
  level: LoggingLevel;

  /**
   * Сообщение лога.
   */
  message: string;

  /**
   * Stacktrace ошибки .
   */
  stacktrace: string;

  constructor(
    logger: string,
    level: LoggingLevel,
    message: string,
    stacktrace: string
  ) {
    this.logger = logger;
    this.level = level;
    this.message = message;
    this.stacktrace = stacktrace;
  }
}
